import { Pagination } from '@/helpers/pagination';
import { FilterGroup } from '@/types/filter';

export function generateFilterQuery(
  url: URL,
  filterGroupsWithSelection: FilterGroup[],
  pagination: Pagination,
  clearAllFilters: boolean = false,
): string {
  url.search = '';

  if (!clearAllFilters) {
    filterGroupsWithSelection.forEach((group) => {
      group.values.forEach((filter) => {
        url.searchParams.append(`${group.fieldname}[]`, filter.value);
      });
    });

    url.searchParams.set('page', pagination.current.toString());
  }

  return url.searchParams.toString();
}
